import React from "react";
import "./divider.css";
const Hdivider = () => {
  return <div className="separator text-lg my-6"></div>;
};

export default Hdivider;
